module.exports = __webpack_public_path__ + "media/images/emblems/Oberburg-coat_of_arms-d69195c98baf40e28dcb5d50d5ecea29.svg";